import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    SUPPLIERS_QUERY,
    SINGLE_SUPPLIER_QUERY,
    CREATE_SUPPLIER_MUTATION,
    UPDATE_SUPPLIER_MUTATION,
    DELETE_SUPPLIER_MUTATION
} from "@/graphql/suppliers.js";

const state = {
    suppliers: []
};
const getters = {};
const mutations = {
    [types.SET_SUPPLIERS](state, suppliers) {
        state.suppliers = suppliers;
    },
    [types.SORT_SUPPLIERS](state) {
        state.suppliers.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_SUPPLIER](state, supplier) {
        var index = state.suppliers.findIndex(function(element) {
            return element.node.id == supplier.id;
        });

        const node = { node: supplier };

        if (index > -1) {
            state.suppliers.splice(index, 1, node);
        } else {
            state.suppliers.unshift(node);
        }
    },
    [types.DELETE_SUPPLIER](state, supplier) {
        var index = state.suppliers.find(function(element, index) {
            if (element.id == supplier.id) {
                return index;
            }
        });

        if (index > -1) {
            state.suppliers.splice(index, 1);
        }
    }
};
const actions = {
    async fetchSuppliers(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SUPPLIERS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);

                    const suppliers = response.data.suppliers.edges;

                    // update store
                    context.commit(types.SET_SUPPLIERS, suppliers);

                    // sort
                    context.commit(types.SORT_SUPPLIERS);

                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglSupplier(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_SUPPLIER_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const supplier = JSON.parse(
                        JSON.stringify(response.data.supplier)
                    );

                    // update store
                    context.commit(types.UPSERT_SUPPLIER, supplier);

                    // sort
                    context.commit(types.SORT_SUPPLIERS);

                    resolve(supplier);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createSupplier(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_SUPPLIER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const supplier = response.data.createSupplier.supplier;

                    // update store
                    context.commit(types.UPSERT_SUPPLIER, supplier);

                    // sort
                    context.commit(types.SORT_SUPPLIERS);

                    resolve(supplier);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateSupplier(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_SUPPLIER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const supplier = response.data.updateSupplier.supplier;

                    // update store
                    context.commit(types.UPSERT_SUPPLIER, supplier);

                    // sort
                    context.commit(types.SORT_SUPPLIERS);

                    resolve(supplier);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteSupplier(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_SUPPLIER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const supplier = response.data.deleteSupplier.supplier;

                    // update store
                    context.commit(types.DELETE_SUPPLIER, supplier);

                    resolve(supplier);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
